import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es7.promise.finally.js";
import debounce from 'lodash/debounce';
import { FAST_TIMER } from '~/const/timers';
export default {
  data: function data() {
    return {
      initialPageYOffset: 0
    };
  },
  methods: {
    handleScroll: debounce(function handleDebounche() {
      window.scrollTo(0, this.initialPageYOffset);
    }, FAST_TIMER),
    disableWindowScroll: function disableWindowScroll() {
      if (this.isMobile()) {
        window.document.querySelector('body').style.overflow = 'hidden';
        return;
      }

      this.initialPageYOffset = window.pageYOffset;
      window.addEventListener('scroll', this.handleScroll, false);
    },
    enableWindowScroll: function enableWindowScroll() {
      window.document.querySelector('body').style.overflow = '';
      window.removeEventListener('scroll', this.handleScroll, false);
    }
  }
};